<template>
    <b-modal id="modal-kirim-dus" size="lg" :title="`Kirim ${dusWord}`" centered no-close-on-backdrop no-close-on-esc hide-footer @show="resetForm" @hidden="resetForm">

        <div class="detail-data-wrapper mb-3">
            <h6 class="form-title mb-2">{{ dusWord }} yang akan dikirim ({{ pendingDuses.length }})</h6>
            <div class="d-flex flex-wrap">
                <b-badge variant="primary" class="mr-2 mb-2" v-for="item in pendingDusSummary" :key="item.label">{{ item.label }} ({{ item.count }})</b-badge>
            </div>
        </div>

        <b-form-group label="Titik Drop Off">
            <b-form-select v-model="tujuan" :options="tujuanOptions" name="kirimDusTujuan" />
        </b-form-group>

        <b-form-group label="Cabang Drop Off" v-if="tujuan == 'dropoff'">
            <multiselect
                name="kirimDusCabangTujuan"
                v-model="cabangTujuan"
                :options="cabangOptions"
                :internal-search="true"
                :allow-empty="false"
                deselect-label=""
                select-label=""
                label="name"
                track-by="id"
                placeholder="-- Pilih cabang --"
            />
        </b-form-group>

        <b-form-group label="Metode Pengiriman">
            <multiselect
                name="kirimDusMetode"
                v-model="metode"
                :options="metodeOptions"
                :internal-search="true"
                :allow-empty="false"
                deselect-label=""
                select-label=""
                label="name"
                track-by="id"
                placeholder="-- Pilih metode --"
            />
        </b-form-group>

        <b-form-checkbox v-if="isDitolakDropoff" v-model="useFotoSebelumnya" class="mb-2" name="useFotoSebelumnya">
            Gunakan foto sebelumnya
        </b-form-checkbox>

        <div class="mb-3" v-if="useFotoSebelumnya">
            <ModalFoto isButton size="" buttonLabel="Lihat Foto Sebelumnya" title="Foto Sebelumnya" :photos="shipmentPhotoUrls" />
        </div>

        <div class="form-content-wrapper" v-if="!useFotoSebelumnya">
            <b-button variant="pgiBtn" class="mb-2" @click="addFotoDus" name="fotoDusAddBtn">
                <i class="fa fa-plus mr-2"></i>Tambah Foto
            </b-button>

            <FotoPendukung
                v-for="item in fotoDus" v-bind:key="item.index"
                :fotoPendukung="item"
                :length="fotoDus.length"
                :minLength="minLengthFotoDus"
                :lat="lat"
                :long="long"
                :isRemove="fotoDus.length > minLengthFotoDus"
                @remove="removeFotoDus"
                @showModalCam="openModalCam"
                @showModalPreview="openModalPreview"
            />
        </div>

        <div class="form-wrapper-btn text-right">
            <b-button variant="pgiBtn" name="kirimDusSubmitBtn" :disabled="!canSubmit" @click="openConfirm">
                <i class="fa fa-send mr-2"></i>
                Kirim
            </b-button>
        </div>

        <ModalConfirm id="modal-confirm-kirim-dus" :title="`Confirm Kirim ${dusWord}`" :isSubmitting="isSubmitting" :desc="`Apakah anda yakin untuk mengirim semua ${dusWord.toLowerCase()}? Status seluruh barang di dalamnya akan berubah jadi Pengiriman.`" @submit="onSubmitKirim" />
        <ModalWebCam idWebcam="webcam-kirim-dus" @photoTaken="setResult" />
        <ModalPreview modalId="modal-preview-kirim-dus" :fotoPreview="activeFotoPreview" />
    </b-modal>
</template>

<script>
import FotoPendukung from '../../../components/webcam/FotoPendukung'
import ModalWebCam from '../../../components/webcam/ModalWebCam'
import ModalPreview from '../../../components/webcam/ModalPreview'
import ModalFoto from '@/components/modals/ModalFoto'
import CONSTANTS from '@/constants'

export default {
    name: 'modal-kirim-dus',
    components: {
        FotoPendukung,
        ModalWebCam,
        ModalPreview,
        ModalFoto,
    },
    props: {
        id: { type: [String, Number], required: true },
        dusWord: { type: String, default: 'Dus' },
        pendingDuses: { type: Array, required: true },
        cabangOptions: { type: Array, default: () => [] },
        metodeOptions: { type: Array, default: () => [] },
        shipmentStatus: { type: Number, default: null },
        shipmentPhotoUrls: { type: Array, default: () => [] },
    },
    data() {
        return {
            tujuan: 'sendiri',
            tujuanOptions: [
                { value: 'sendiri', text: 'Cabang Sendiri' },
                { value: 'dropoff', text: 'Titip Cabang Lain' },
            ],
            cabangTujuan: null,

            metode: null,

            useFotoSebelumnya: false,

            fotoDus: [],
            indexFotoDus: 0,
            activeFotoDusIndex: null,
            activeFotoPreview: '',
            lat: 0,
            long: 0,

            isSubmitting: false,
        }
    },
    computed: {
        isDitolakDropoff() {
            return this.shipmentStatus == CONSTANTS.LELANG_PACKING.SHIPMENT_STATUS.DITOLAK_DROPOFF
        },
        pendingDusSummary() {
            const counts = {}
            this.pendingDuses.forEach(dus => {
                counts[dus.dusType] = (counts[dus.dusType] || 0) + 1
            })
            return Object.keys(counts).map(dusType => ({
                label: dusType,
                count: counts[dusType],
            }))
        },
        minLengthFotoDus() {
            return Math.min(Math.max(this.pendingDuses.length, 1), 15)
        },
        canSubmit() {
            if (this.pendingDuses.length == 0) return false
            if (!this.metode) return false
            if (!this.useFotoSebelumnya) {
                if (this.fotoDus.length == 0) return false
                if (this.fotoDus.some(item => item.isUploading)) return false
                if (this.fotoDus.some(item => !item.publicUrl)) return false
            }
            if (this.tujuan == 'dropoff' && !this.cabangTujuan) return false
            return true
        },
    },
    methods: {
        makeFotoDus() {
            return {
                id: 0,
                index: this.indexFotoDus++,
                checkFotoBarangPendukung: false,
                fotoBarangPendukungPlaceholder: `Pilih foto ${this.dusWord.toLowerCase()}`,
                fotoBarangPendukung: null,
                fotoBarangPendukungBase64: null,
                activeFotoPendukungBase64: null,
                publicUrl: null,
                isUploading: false,
            }
        },

        addFotoDus() {
            if (this.fotoDus.length >= 15) {
                this.$helper.toastErr(this, `Foto ${this.dusWord} maksimal 15 foto!`)
                return
            }

            this.fotoDus.unshift(this.makeFotoDus())
        },

        removeFotoDus(index) {
            this.fotoDus = this.fotoDus.filter(item => item.index != index)
        },

        openModalCam(index) {
            this.activeFotoDusIndex = index
            this.$bvModal.show('webcam-kirim-dus')
        },

        openModalPreview(index) {
            let idx = this.fotoDus.findIndex(item => item.index == index)
            this.activeFotoPreview = this.fotoDus[idx].activeFotoPendukungBase64
            this.$bvModal.show('modal-preview-kirim-dus')
        },

        async setResult(result) {
            let formattedDate = this.$helper.formatTanggalDMY()
            let waktu = this.$helper.waktu24()

            var newResult = await this.$helper.resizeImage(result)

            let img = new Image()
            img.src = newResult
            img.onload = () => {
                let canvas = document.createElement('canvas')
                let ctx = canvas.getContext('2d')
                canvas.setAttribute('width', img.width)
                canvas.setAttribute('height', img.height)

                ctx.drawImage(img, 0, 0)
                ctx.font = '14pt Arial'
                ctx.fillStyle = '#ffffff'
                ctx.fillText(formattedDate + ' ' + waktu, 10, img.height - 40)
                ctx.strokeText(formattedDate + ' ' + waktu, 10, img.height - 40)
                ctx.fillText(this.lat + ' ' + this.long, 10, img.height - 10)
                ctx.strokeText(this.lat + ' ' + this.long, 10, img.height - 10)

                let newBase64Str = canvas.toDataURL('image/jpeg', 0.9)
                let idx = this.fotoDus.findIndex(item => item.index == this.activeFotoDusIndex)
                this.fotoDus[idx].fotoBarangPendukungBase64 = newBase64Str
                this.fotoDus[idx].activeFotoPendukungBase64 = newBase64Str
                this.fotoDus[idx].fotoBarangPendukungPlaceholder = 'Foto dari Kamera'
                this.fotoDus[idx].checkFotoBarangPendukung = true
            }

            this.$bvModal.hide('webcam-kirim-dus')
        },

        openConfirm() {
            if (!this.useFotoSebelumnya) {
                if (this.fotoDus.some(item => item.isUploading)) {
                    return this.$helper.toastErr(this, "Masih ada foto yang sedang diupload, mohon tunggu.")
                }
                if (this.fotoDus.some(item => !item.publicUrl)) {
                    return this.$helper.toastErr(this, `Masih ada foto ${this.dusWord.toLowerCase()} yang belum diupload!`)
                }
            }

            if (!this.canSubmit) return
            this.$bvModal.show('modal-confirm-kirim-dus')
        },

        isValidFotoType(file) {
            if (!file) return true // hasil kamera, selalu jpeg

            const type = (file.type || '').toLowerCase()
            const name = (file.name || '').toLowerCase()

            return ['image/jpeg', 'image/jpg', 'image/png'].includes(type)
                || name.endsWith('.jpg') || name.endsWith('.jpeg') || name.endsWith('.png')
        },

        async uploadFotoDus(item) {
            if (item.isUploading || item.publicUrl) return

            if (!this.isValidFotoType(item.fotoBarangPendukung)) {
                this.$helper.toastErr(this, "Foto harus berformat JPG, JPEG, atau PNG!")
                item.fotoBarangPendukung = null
                item.fotoBarangPendukungBase64 = null
                item.activeFotoPendukungBase64 = null
                item.checkFotoBarangPendukung = false
                return
            }

            item.isUploading = true
            this.$store.dispatch("loading/show", { progress: 0 })
            try {
                const blob = await (await fetch(item.activeFotoPendukungBase64)).blob()

                const response = await this.$helper.uploadPresigned({
                    vue: this,
                    path: `lelang-packing/${this.id}/shipment/create-presigned-url`,
                    fileUpload: blob,
                    contentType: 'image/jpeg',
                    onUploadProgress: progress => this.$store.dispatch("loading/setProgress", Math.min(progress, 100)),
                    useXhr: true,
                })

                if (response.success) {
                    item.publicUrl = response.publicUrl
                    item._uploadedForBase64 = item.activeFotoPendukungBase64
                } else {
                    item.activeFotoPendukungBase64 = null
                }
            } finally {
                item.isUploading = false
                this.$store.dispatch("loading/hide")
            }
        },

        getPhotoKey(publicUrl) {
            return String(publicUrl).replace(/^https?:\/\/[^/]+\//, "")
        },

        onSubmitKirim() {
            this.isSubmitting = true

            const body = {
                // [Sementara] tujuan (cabang sendiri / drop off) belum ada di API, nyusul nanti
                dropOffCabangId: this.tujuan == 'dropoff' && this.cabangTujuan ? this.cabangTujuan.id : null,
                deliveryChannelId: this.metode ? this.metode.id : null,
                useExistingPhotos: this.useFotoSebelumnya,
            }

            if (!this.useFotoSebelumnya) {
                body.photoKeys = this.fotoDus.filter(item => item.publicUrl).map(item => this.getPhotoKey(item.publicUrl))
            }

            this.$axios.post(`lelang-packing/${this.id}/shipment`, body).then(() => {
                this.$bvModal.hide('modal-confirm-kirim-dus')
                this.$bvModal.hide('modal-kirim-dus')

                this.$helper.toastSucc(this, `${this.dusWord} berhasil dikirim!`)
                this.$emit('submitted')
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },

        resetForm() {
            this.tujuan = 'sendiri'
            this.cabangTujuan = null
            this.metode = null
            this.useFotoSebelumnya = false
            this.indexFotoDus = 0
            this.fotoDus = Array.from({ length: this.minLengthFotoDus }, () => this.makeFotoDus())
        },
    },
    watch: {
        // Upload otomatis begitu foto (browse/camera) selesai diproses jadi base64 —
        // dan kalau fotonya diganti setelah pernah ke-upload, re-upload ulang.
        fotoDus: {
            deep: true,
            handler(list) {
                list.forEach(item => {
                    if (item.publicUrl && item._uploadedForBase64 !== item.activeFotoPendukungBase64) {
                        item.publicUrl = null
                    }
                    if (item.activeFotoPendukungBase64 && !item.publicUrl && !item.isUploading) {
                        this.uploadFotoDus(item)
                    }
                })
            },
        },
    },
    created() {
        navigator.geolocation.getCurrentPosition(position => {
            this.lat = position.coords.latitude
            this.long = position.coords.longitude
        })
    },
}
</script>
